import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(n: number, locale = "es-PE"): string {
  return new Intl.NumberFormat(locale).format(n);
}

export function formatPercent(n: number | null | undefined, locale = "es-PE"): string {
  if (n == null) return "—";
  return `${n >= 0 ? "+" : ""}${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(n)}%`;
}
